// トレーニング.
export interface Training {
  day: string;
  duration: string;
  subject: string;
  instructor: string;
  remarks: string;
  datetime: string;

  print: number;
  datetimeT: string;
}

export enum type {
  None = 0,
  Show,
  Edit,
  Delete,
}

// チェックボックスの状況.
export interface CheckData {
  id: number;
  selected: boolean;
}

// 新規用フォーマット.
export interface NewParamFormat {
  datetime: string;
  duration: string;
  subject: string;
  instructor: string;
  remarks: string;
}

// 更新用フォーマット(datetimeがない).
export interface UpdateParamFormat {
  duration: string;
  subject: string;
  instructor: string;
  remarks: string;
}


// WEBPACK FOOTER //
// ./src/constants/Kiroku.tsx